import React, {Component} from 'react';
import type {License} from "amn/model/account/Subscription";
import Box from "@material-ui/core/Box";
import {connect} from "react-redux";
import {WhiteBox} from "amn/ui/containers/Boxes";
import Button from "@material-ui/core/Button";
import {makeAccountLicenseSelector} from "amn/store/selectors/account/account-licenses.selectors";
import Typography from "@material-ui/core/Typography";
import GetAppOutlinedIcon from '@material-ui/icons/GetAppOutlined';
import {NavLink} from "react-router-dom";
import PortalPaths from "amn/modules/common/routes/PortalPaths";
import Link from "@material-ui/core/Link";
import Config from "amn/Config";
import AccountLicenseActivationToken from "./AccountLicenseActivationToken";
import SuccessIcon from "amn/ui/images/SuccessIcon";

type Props = {
  license: License;
};

class AccountLicenseCreationSuccess extends Component<Props> {


  render() {

    return (
      <Box p={4} mt={4} textAlign="center">
        {this.renderSuccessMessage()}

        {this.renderStepNumber(1)}

        {this.renderDownloadStep()}

        <Box height={16}/>

        {this.renderStepNumber(2)}

        {this.renderActivationStep()}

        <Box mt={4}>
          <Button component={NavLink}
                  to={PortalPaths.accountLicensesUrl()}
                  color="primary"
                  variant="contained">Aller à mon compte</Button>
        </Box>

      </Box>
    );
  }

  renderSuccessMessage = () => {
    return (
      <Box textAlign="center">
        <Box mb={1}>
          <SuccessIcon width={80} height={80}/>
        </Box>
        <div>
          <Typography variant="subtitle2" color="secondary">
            Votre license a été créée avec succès
          </Typography>
        </div>
        <Box mt={2}>
          <Typography variant="subtitle1" color="secondary">
            Pour commencer à utiliser Amn Auditor, suivez les étapes ci-dessous !
          </Typography>
        </Box>
      </Box>
    );
  }

  renderDownloadStep = () => {
    return (
      <WhiteBox mt={2} mb={4} p={4} pl={8} pr={8}>

        <Box mt={3} alignItems="flex-end" flexDirection="column">
          <img src={require("assets/images/logo/amn-auditor.svg")}
               style={{maxHeight: 60, minWidth: 120}}
               alt="Amn Brains"/>

        </Box>
        <Box mt={4} color="secondary.main">
          <Box>
            Télécharger et installer l'application sur la machine que vous aimeriez utiliser.
          </Box>
          <Box mt={2}>
            <b>ATTENTION</b>
          </Box>
          <Box mt={2}>
            Une licence est activable sur une seule machine. Il est donc important d'installer
            l'application sur la machine sur laquelle vous allez activer votre licence.
          </Box>
        </Box>

        <Box mt={6} mb={2}>

          {/*<Box mb={1}*/}
          {/*     fontSize="caption.fontSize"*/}
          {/*     display="flex"*/}
          {/*     color="secondary.main"*/}
          {/*     justifyContent="center"*/}
          {/*     alignItems="center">*/}
          {/*  <WindowsIcon style={{fontSize: 16}}/> &nbsp; disponible pour Microsoft Windows*/}
          {/*</Box>*/}
          <Button startIcon={<GetAppOutlinedIcon/>}
                  variant="outlined"
                  component="a"
                  href={Config.AMN_AUDITOR.INSTALLER_LINK}
                  target="_blank"
                  color="secondary">
            Télécharger l'application Windows
          </Button>
          <Box mt={1}
               fontSize="caption.fontSize"
               display="flex"
               color="secondary.main"
               justifyContent="center"
               alignItems="center">
            <Link startIcon={<GetAppOutlinedIcon/>}
                  component="a"
                  href={Config.AMN_AUDITOR.PORTABLE_LINK}
                  target="_blank"
                  color="primary">
              Télécharger la version portable
            </Link>
          </Box>
        </Box>

      </WhiteBox>
    );
  }

  renderActivationStep() {
    const {license} = this.props;
    const activationToken = license?.activationToken;
    return (
      <WhiteBox mt={2} p={4}>


        <Box mt={3} alignItems="flex-end" flexDirection="column">

          <svg width={80} height={80} viewBox="0 0 226 226">
            <g>
              <path d="M0,226v-226h226v226z" fill="none"/>
              <g>
                <path
                  d="M151.84375,15.89063h-95.34375c-9.71094,0 -17.65625,7.94531 -17.65625,17.65625v158.90625c0,9.71094 7.94531,17.65625 17.65625,17.65625h113c9.71094,0 17.65625,-7.94531 17.65625,-17.65625v-141.25c0,-19.42187 -15.89062,-35.3125 -35.3125,-35.3125z"
                  fill="#ffffff"/>
                <path
                  d="M100.64063,184.86094c-0.35313,0 -0.70625,0 -1.05938,-0.17656c-0.35313,0 -0.70625,-0.17656 -1.05938,-0.35313c-0.35313,-0.17656 -0.52969,-0.35313 -0.88281,-0.52969c-0.35313,-0.17656 -0.52969,-0.35313 -0.88281,-0.70625c-0.17656,-0.17656 -0.52969,-0.52969 -0.70625,-0.88281c-0.17656,-0.35313 -0.35313,-0.52969 -0.52969,-0.88281c-0.17656,-0.35313 -0.17656,-0.70625 -0.35313,-1.05937c0,-0.35313 -0.17656,-0.70625 -0.17656,-1.05937c0,-0.35313 0,-0.70625 0.17656,-1.05937c0,-0.35313 0.17656,-0.70625 0.35313,-1.05937c0.17656,-0.35313 0.35313,-0.70625 0.52969,-0.88281c0.17656,-0.35313 0.35313,-0.52969 0.70625,-0.88281c0.17656,-0.17656 0.52969,-0.52969 0.88281,-0.70625c0.35313,-0.17656 0.52969,-0.35313 0.88281,-0.52969c0.35313,-0.17656 0.70625,-0.17656 1.05938,-0.35313c0.70625,-0.17656 1.4125,-0.17656 2.11875,0c0.35313,0 0.70625,0.17656 1.05938,0.35313c0.35313,0.17656 0.70625,0.35313 0.88281,0.52969c0.35313,0.17656 0.52969,0.35313 0.88281,0.70625c0.17656,0.17656 0.52969,0.52969 0.70625,0.88281c0.17656,0.35313 0.35313,0.52969 0.52969,0.88281c0.17656,0.35313 0.17656,0.70625 0.35313,1.05937c0,0.35313 0.17656,0.70625 0.17656,1.05937c0,0.35313 0,0.70625 -0.17656,1.05937c0,0.35313 -0.17656,0.70625 -0.35313,1.05937c-0.17656,0.35313 -0.35313,0.70625 -0.52969,0.88281c-0.17656,0.35313 -0.35313,0.52969 -0.70625,0.88281c-1.05938,1.05937 -2.47188,1.76563 -3.88438,1.76563zM131.53906,188.92188c-3.53125,0 -6.70937,-1.94219 -8.12187,-5.12031v-0.17656c-1.58906,1.23594 -3.70781,1.4125 -5.65,0.52969c-2.64844,-1.23594 -3.70781,-4.41406 -2.29531,-7.0625c1.58906,-3.17812 4.76719,-5.12031 8.29844,-5.12031c3.17812,0 6.00313,1.58906 7.59219,4.06094l1.4125,-4.59062c1.23594,-3.88438 4.76719,-6.70937 8.82813,-7.0625c4.06094,-0.35313 7.94531,1.76563 9.8875,5.29688l3.53125,6.70937c0.52969,1.05937 1.4125,1.23594 1.94219,1.4125c0.52969,0 1.4125,0 2.29531,-0.70625c2.11875,-2.11875 5.47344,-2.11875 7.41563,0c2.11875,2.11875 2.11875,5.47344 0,7.41563c-3.00156,3.00156 -7.0625,4.41406 -11.3,3.70781c-4.2375,-0.70625 -7.76875,-3.17812 -9.71094,-6.88594l-3.17812,-5.82656l-2.11875,7.0625c-1.05937,3.53125 -4.2375,6.17969 -7.94531,6.35625c-0.35312,0 -0.52969,0 -0.88281,0z"
                  fill="#109cf1"/>
                <path
                  d="M151.84375,109.46875h-77.6875c-3.00156,0 -5.29687,-2.29531 -5.29687,-5.29687c0,-3.00156 2.29531,-5.29687 5.29688,-5.29687h77.6875c3.00156,0 5.29688,2.29531 5.29688,5.29688c0,3.00156 -2.29531,5.29688 -5.29687,5.29688zM134.1875,56.5h-42.375c-3.00156,0 -5.29687,-2.29531 -5.29687,-5.29687c0,-3.00156 2.29531,-5.29687 5.29688,-5.29687h42.375c3.00156,0 5.29688,2.29531 5.29688,5.29688c0,3.00156 -2.29531,5.29688 -5.29687,5.29688zM125.35938,135.95313h-51.20312c-3.00156,0 -5.29687,-2.29531 -5.29687,-5.29687c0,-3.00156 2.29531,-5.29687 5.29688,-5.29687h51.20313c3.00156,0 5.29688,2.29531 5.29688,5.29688c0,3.00156 -2.29531,5.29688 -5.29687,5.29688zM151.84375,135.95313c-1.4125,0 -2.825,-0.52969 -3.70781,-1.58906c-0.17656,-0.17656 -0.52969,-0.52969 -0.70625,-0.88281c-0.17656,-0.35313 -0.35313,-0.52969 -0.52969,-0.88281c-0.17656,-0.35313 -0.17656,-0.70625 -0.35313,-1.05937c0,-0.35313 -0.17656,-0.70625 -0.17656,-1.05937c0,-1.4125 0.52969,-2.825 1.58906,-3.70781c0.17656,-0.17656 0.52969,-0.52969 0.88281,-0.70625c0.35313,-0.17656 0.52969,-0.35313 0.88281,-0.52969c0.35313,-0.17656 0.70625,-0.17656 1.05937,-0.35313c1.76563,-0.35313 3.53125,0.17656 4.76719,1.4125c1.05937,1.05937 1.58906,2.29531 1.58906,3.70781c0,0.35313 0,0.70625 -0.17656,1.05937c0,0.35313 -0.17656,0.70625 -0.35313,1.05937c-0.17656,0.35313 -0.35313,0.70625 -0.52969,0.88281c-0.17656,0.35313 -0.35313,0.52969 -0.70625,0.88281c-0.70625,1.23594 -2.11875,1.76563 -3.53125,1.76563z"
                  fill="#e9eef4"/>
                <path
                  d="M187.15625,51.20313h-17.65625c-9.71094,0 -17.65625,-7.94531 -17.65625,-17.65625v-17.65625v0c19.42188,0 35.3125,15.89063 35.3125,35.3125z"
                  fill="#ffffff"/>
                <g fill="#054589">
                  <path
                    d="M180.62344,22.6c-7.76875,-7.76875 -17.83281,-12.00625 -28.77969,-12.00625v0h-95.34375c-12.7125,0 -22.95312,10.24063 -22.95312,22.95313v158.90625c0,12.88906 10.41719,22.95313 19.42188,22.95313h112.64688c15.36094,0 26.48438,-9.71094 26.48438,-22.95312l0.17656,-118.29687c0,-3.00156 -2.29531,-5.29687 -5.29687,-5.29687v0c-3.00156,0 -5.29687,2.29531 -5.29687,5.29688l-0.17656,118.29688c0,7.41563 -6.35625,12.35938 -15.89062,12.35938h-112.64687c-3.00156,0 -8.82812,-5.29687 -8.82812,-12.35937v-158.90625c0,-6.88594 5.47344,-12.35937 12.35938,-12.35937h90.04688v12.35938c0,12.7125 10.24062,22.95313 22.95313,22.95313h16.95c0.17656,0 0.35313,0 0.70625,0v0c2.11875,0 4.06094,-1.4125 4.94375,-3.17813c0.35313,-0.70625 0.52969,-1.4125 0.52969,-2.11875c0,-0.17656 0,-0.52969 0,-0.70625c-0.35312,-10.59375 -4.59062,-20.48125 -12.00625,-27.89687zM157.14063,33.54688v-11.82969c6.00313,1.05937 11.47656,3.88437 15.89063,8.29844c4.41406,4.41406 7.23906,9.8875 8.29844,15.89063h-11.82969c-6.88594,0 -12.35937,-5.47344 -12.35937,-12.35937z"/>
                </g>
              </g>
            </g>
          </svg>

        </Box>

        <Box mt={4} color="secondary.main">
          <Box>
            Une fois l'application est installée et démarrée, <br/>
            utiliser le code d'activation ci-dessous pour activer l'application sur votre machine.
          </Box>
          <Box mt={2}>
            <Box display="inline-block" bgcolor="info.bg">
              Ce code d'activation reste accessible à tout moment sur la lise de vos licences.
            </Box>
          </Box>
        </Box>

        <Box mt={4} mb={1}>
          <Box mb={1} fontWeight="fontWeightMedium" color="secondary.main">
            Code d'activation de la licence
          </Box>
          <AccountLicenseActivationToken activationToken={activationToken}/>
        </Box>

      </WhiteBox>
    );
  }

  renderStepNumber = (number) => {
    return (
      <Box mt={4} display="flex" justifyContent="center">
        <Box fontWeight="fontWeightMedium"
             fontSize="h5.fontSize"
             color="primary.main"
             alignItems="center"
             justifyContent="center"
             display="flex"
          // bgcolor="common.white"
          // width={60}
          // height={60}
          // borderRadius={30}
          // border={1}
             borderColor="primary.main">
          {number}
        </Box>
      </Box>
    )
  }


  static mapStateToProps = (state, props) => {
    const getLicense = makeAccountLicenseSelector(state);
    const license = getLicense(props.licenseId);
    return {
      license
    }
  };
}


export default connect(AccountLicenseCreationSuccess.mapStateToProps)(AccountLicenseCreationSuccess);